import axios from 'axios';
import { installRequestId } from '../utils/requestId';
import { getMarketplaceApiBaseUrl, getMarketplaceDeployOrigin } from './resolveApiBaseUrl';

const API_BASE_URL = process.env.REACT_APP_ITEMS_API_URL ||
  getMarketplaceApiBaseUrl() || 'http://localhost:8080/api';

/** Shared axios client for marketplace item APIs (public engagement + admin). */
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});
installRequestId(api);

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    if (error.response?.status === 401 && !orig._retry) {
      orig._retry = true;
      try {
        const acctUrl = process.env.REACT_APP_API_BASE_URL ||
          getMarketplaceDeployOrigin() || 'http://localhost:8001';
        await axios.post(`${acctUrl}/api/token/refresh/`, {}, { withCredentials: true });
        return api(orig);
      } catch { /* redirect handled elsewhere */ }
    }
    return Promise.reject(error);
  },
);

export default api;
